export enum DEFAULTS {
    homeImage = `../../../../assets/backgrounds/eclipse/eclipse.webp`,
    homeLogo = `../../../../assets/theme/logo-vertical/logo-vertical.webp`,
    teamLogo = `../../../../assets/backgrounds/eclipse/eclipse.webp`,
    teamBg = `../../../../assets/backgrounds/djangogirls/djangogirls.webp`,
}
